import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootAssets } from '../../config/rootAssets';
import { FunctionalArea } from '../../pages/authentication/CreateDealspace';
import { RootState } from '../store';
import { PlayBook } from '../../config/playBook';
import { Dealspace } from '../../config/dealspace';
import sound from '../../assets/camera-sound.mp3';

const initialState: RootAssets = {
  projects: [],
  workspaces: [],
  playbooks: [],
  dealspaces: [],
  invitations: undefined,
  functionalAreas: [],
  currentSelectedDealspace: undefined,
};

export const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    postAssets: (state, action: PayloadAction<RootAssets>) => {
      state.projects = action.payload.projects;
      state.workspaces = action.payload.workspaces;
      state.playbooks = action.payload.playbooks;
      state.dealspaces = action.payload.dealspaces;
      state.invitations = action.payload.invitations;
    },
    postFunctionalAreas: (state, action: PayloadAction<FunctionalArea[]>) => {
      state.functionalAreas = action.payload;
    },
    postPlaybooks: (state, action: PayloadAction<PlayBook[]>) => {
      state.playbooks = action.payload;
    },
    postDealspaces: (state, action: PayloadAction<Dealspace[]>) => {
      state.dealspaces = action.payload;
    },
    postCurrentSelectedDealspace: (
      state,
      action: PayloadAction<Dealspace | undefined>
    ) => {
      state.currentSelectedDealspace = action.payload;
    },
  },
});

export const { postAssets } = assetsSlice.actions;
export const { postFunctionalAreas } = assetsSlice.actions;
export const { postPlaybooks } = assetsSlice.actions;
export const { postDealspaces } = assetsSlice.actions;
export const { postCurrentSelectedDealspace } = assetsSlice.actions;

export const getAssets = (state: RootState) => state.assetsReducer;
export const getAssetsProjects = (state: RootState) =>
  state.assetsReducer.projects;
export const getAssetsWorkspaces = (state: RootState) =>
  state.assetsReducer.workspaces;
export const getAssetsPlaybooks = (state: RootState) =>
  state.assetsReducer.playbooks;
export const getAssetsDealspaces = (state: RootState) =>
  state.assetsReducer.dealspaces;
export const getAssetsInvitations = (state: RootState) =>
  state.assetsReducer.invitations;
export const getAssetsFunctionalAreas = (state: RootState) =>
  state.assetsReducer.functionalAreas;
export const getAssetsCurrentSelectedDealspace = (state: RootState) =>
  state.assetsReducer.currentSelectedDealspace;
export const getSound = (state: RootState) => sound;

export default assetsSlice.reducer;
